import React from 'react';
import PropTypes from 'prop-types';
import Link from 'shared/components/Link';
import { numberWithSpaces } from 'shared/helpers/common';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';

// eslint-disable-next-line css-modules/no-unused-class
import s from './AdvertTitle.css';

const TitleLeasingLink = ({ monthlyPayment, onClick, t }) =>
  monthlyPayment !== undefined && (
    <Link onClick={onClick} className={s.titleLeasingLink}>
      {t('в лизинг')} {t('от')} {numberWithSpaces(parseInt(monthlyPayment, 10))} $ {t('в месяц')}
      <i className="fa fa-car" />
    </Link>
  );

TitleLeasingLink.propTypes = {
  monthlyPayment: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(s)(withTranslate(TitleLeasingLink));



// WEBPACK FOOTER //
// ./src/desktop/components/AdvertTitle/AdvertTitleLeasingLink.js